import { isIterable } from "@thi.ng/checks";
import { comp } from "../func/comp";
import { normRange } from "../iter/norm-range";
import { iterator } from "../iterator";
import { map } from "./map";
import { mapcat } from "./mapcat";
import { partition } from "./partition";
// prettier-ignore
export function interpolate(fn, window, n, src) {
    return isIterable(src)
        ? iterator(interpolate(fn, window, n), src)
        : comp(partition(window, 1), mapcat((chunk) => map((t) => fn(chunk, t), normRange(n, false))));
}
